import { gql } from '@apollo/client';

const listSqlPipelineExecutions = (sqlPipelineUri: string, stage: string) => {
    return {
        variables: {
            sqlPipelineUri,
            stage,
        },
        query: gql`
            query ListSqlPipelineExecutions(
                $sqlPipelineUri: String!
                $stage: String
            ) {
                listSqlPipelineExecutions(
                    sqlPipelineUri: $sqlPipelineUri
                    stage: $stage
                ) {
                    count
                    page
                    pages
                    hasNext
                    hasPrevious
                    nodes {
                        name
                        status
                        startDate
                        stopDate
                    }
                }
            }
        `,
    };
};

export default listSqlPipelineExecutions;
